<template>
    <div class="quiz">
        <div class="fond"></div>
        <div class="logo">
            <router-link to="/">
                <img src="../assets/logo-white.svg"/>
            </router-link>
        </div>
        <div class="content" v-if="this.score!=='0'">
            <h1>Herzlichen Glückwunsch!</h1>
            <h2>Sie haben {{ textScore }} von drei Fragen<br>richtig beantwortet!</h2>
            <p><router-link to="/" class="button">WEITER</router-link></p>
        </div>
        <div class="content" v-else>
            <h1>Mehr Glück beim nächsten Mal!</h1>
            <h2>Leider haben Sie keine Frage richtig beantwortet</h2>
            <p><router-link to="/" class="button">WEITER</router-link></p>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'Result',
        props: ['score'],

        computed: {
            textScore() {
                switch (this.score) {
                    case '1':
                        return 'eine';
                    case '2':
                        return 'zwei';
                    case '3':
                        return 'drei';
                    default:
                        return 'keine';
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    div.quiz {
        color: white;
        z-index: 1;
    }

    .content {
        position: absolute;
        z-index: 1;
        left: 10%;
        top: 390px;
        width: 80%;

    }

    .fond {
        background-color: transparentize(#002438, .1);
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .logo {
        position: absolute;
        width: 370px;
        right: 60px;
        top: 60px;

        img {
            width: 100%;
            height: auto;
        }
    }

    h1, h2 {
        font-size: 50px;
        margin: 0;
    }

    h2 {
        margin-bottom: 60px;
    }


    p {
        margin: 0;
    }

    .button {
        background-color: #B71E3F;
        text-align: center;
        display: inline-block;
        color: white;
        padding: 0.5rem 1.5rem;
        text-decoration: none;
        border-radius: 5px;
    }

    .text {
        margin: 1rem 0 2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Result.vue